(function () {
    'use strict';

    angular
        .module('appback')
        .controller('SelloutController', SelloutController)

    SelloutController.$inject = ["SelloutService"];

    /**
     * Sell-out de distribuidores: pestaña Cartera (último informe de cada
     * distribuidor, filtrable por país) y Detalle de un informe.
     */
    function SelloutController(SelloutService) {
        var sc = this;

        // Cobertura (meses de stock) fuera de la cual se avisa; las mismas que common\helpers\SelloutHelper.
        var COBERTURA_MINIMA = 1.5;
        var COBERTURA_MAXIMA = 6;
        var CONCENTRACION = 30;

        sc.tab = 'cartera';
        sc.paisId = '';
        sc.cartera = { loading: true, error: false, data: null };
        sc.informeId = '';
        sc.informe = { loading: false, error: false, data: null };

        sc.init = function () {
            sc.cargarCartera();
        };

        sc.cargarCartera = function () {
            sc.cartera.loading = true;
            sc.cartera.error = false;

            SelloutService.GetCartera(sc.paisId).then(function (data) {
                sc.cartera.data = data;
            }, function () {
                sc.cartera.error = true;
            }).finally(function () {
                sc.cartera.loading = false;
            });
        };

        sc.cambiarTab = function (tab) {
            sc.tab = tab;
        };

        // Desde una fila de la cartera: su informe en la pestaña Detalle.
        sc.verDetalle = function (fila) {
            sc.informeId = String(fila.id);
            sc.tab = 'detalle';
            sc.cargarInforme();
        };

        sc.informesFiltrados = function () {
            var informes = sc.cartera.data ? sc.cartera.data.informes : [];
            return informes.filter(function (informe) {
                return !sc.paisId || String(informe.paisId) === String(sc.paisId);
            });
        };

        sc.cargarInforme = function () {
            sc.informe.data = null;
            sc.informe.error = false;
            if (!sc.informeId) {
                return;
            }
            sc.informe.loading = true;

            SelloutService.GetInforme(sc.informeId).then(function (data) {
                sc.informe.data = data;
            }, function () {
                sc.informe.error = true;
            }).finally(function () {
                sc.informe.loading = false;
            });
        };

        sc.importe = function (valor, moneda) {
            if (valor === null || valor === undefined) {
                return '—';
            }

            try {
                return new Intl.NumberFormat('es-ES', { style: 'currency', currency: moneda || 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(valor);
            } catch (e) {
                return Number(valor).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + (moneda || '');
            }
        };

        sc.numero = function (valor, decimales) {
            if (valor === null || valor === undefined) {
                return '—';
            }

            return Number(valor).toLocaleString('es-ES', { minimumFractionDigits: decimales || 0, maximumFractionDigits: decimales || 0 });
        };

        sc.porcentaje = function (valor) {
            if (valor === null || valor === undefined) {
                return '—';
            }

            return (valor > 0 ? '+' : '') + Number(valor).toFixed(1) + '%';
        };

        sc.concentrada = function (top1) {
            return top1 !== null && top1 > CONCENTRACION;
        };

        sc.claseCobertura = function (alerta) {
            return alerta.cobertura < COBERTURA_MINIMA ? 'text-danger' : (alerta.cobertura > COBERTURA_MAXIMA ? 'so-warning' : '');
        };

        // Puntos "x,y" de la línea de evolución de la demanda (viewBox 120x30).
        sc.sparkline = function (demanda) {
            if (!demanda || demanda.length < 2) {
                return '';
            }
            var valores = demanda.map(function (d) { return d.unidades; });
            var min = Math.min.apply(null, valores);
            var max = Math.max.apply(null, valores);
            var rango = max - min || 1;

            return valores.map(function (v, i) {
                var x = (i / (valores.length - 1)) * 116 + 2;
                var y = 28 - ((v - min) / rango) * 26;
                return x.toFixed(1) + ',' + y.toFixed(1);
            }).join(' ');
        };

        // Último punto de la línea, para marcarlo.
        sc.ultimoPunto = function (demanda) {
            var puntos = sc.sparkline(demanda).split(' ');
            var ultimo = (puntos[puntos.length - 1] || '0,0').split(',');
            return { x: ultimo[0], y: ultimo[1] };
        };
    }
})();
